/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The BagusageQueryResult model module.
 * @module model/BagusageQueryResult
 * @version 1.0
 */
class BagusageQueryResult {
    /**
     * Constructs a new <code>BagusageQueryResult</code>.
     * @alias module:model/BagusageQueryResult
     */
    constructor() { 
        
        BagusageQueryResult.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BagusageQueryResult</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BagusageQueryResult} obj Optional instance to populate.
     * @return {module:model/BagusageQueryResult} The populated <code>BagusageQueryResult</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BagusageQueryResult();

            if (data.hasOwnProperty('bagType')) {
                obj['bagType'] = ApiClient.convertToType(data['bagType'], 'String');
            }
            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('quantity')) {
                obj['quantity'] = ApiClient.convertToType(data['quantity'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} bagType
 */
BagusageQueryResult.prototype['bagType'] = undefined;

/**
 * @member {String} date
 */
BagusageQueryResult.prototype['date'] = undefined;

/**
 * @member {Number} id
 */
BagusageQueryResult.prototype['id'] = undefined;

/**
 * @member {Number} quantity
 */
BagusageQueryResult.prototype['quantity'] = undefined;






export default BagusageQueryResult;

